import React, { Component } from "react";
import uploadIcon from '../../../assets/images/Icon feather-upload-cloud.png';
import { connect } from "react-redux";
import { taxPaymentAction } from "../../../store/actions/file-conversion/tax-payment";
import FileUpload from '../../../components/file-upload';
import { format } from "date-fns";
import { Buffer } from 'buffer'

class TaxPaymentsView extends Component {
  constructor(props) {
    super(props);
  }

  state = { src: null, file: null, fileConvertError: false };

  onSelectFileTaxPayment = (e, drop) => {

    let file = drop ? e.dataTransfer.files[0] : e.target.files[0];
    if (!file) return;
    let reader = new FileReader();
    this.setState({
      file: file,
      fileConvertError: null,
      taxPaymentFileName: file.name,
    });
    reader.readAsDataURL(file);
    reader.onload = (res) =>
      this.setState({
        src: res.target.result,
      });
  };

  uploadFile = async (fileInput) => {
    const i = this.state.src.indexOf("base64,");
    const buffer = Buffer.from(this.state.src.slice(i + 7), "base64");
    const file = new File([buffer], "name", {
      type: "application/vnd.ms-excel",
    });

    const fd = new FormData();
    fd.append("file", file);
    fd.append("filename", file.name);
    await this.props.taxPaymentAction(fd);
    let taxPayment = this.props.TaxPaymentReducer;

    if (taxPayment === undefined && taxPayment.msg === "Error converting file")
      return this.setState({ fileConvertError: taxPayment.msg });
    const url = window.URL.createObjectURL(
      new Blob([taxPayment], { type: "application/*" })
    );


    fileInput.current.value = null;
    this.setState({
      src: null,
      taxPaymentFileName: "",
    });
    let date = new Date();
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute(
      "download",
      `Tax-payments-${format(date, "MM-dd-yy-mmss")}.iif`
    );
    document.body.appendChild(link);
    link.click();
  };

  onDrop = e => {
    e.preventDefault();
    this.setState({ dragging: false });
    this.onSelectFileTaxPayment(e, true);
  };

  onDragOver = (e) => {
    this.setState({ dragging: true });
    e.preventDefault();
  };

  onDragEnd = () => this.setState({ dragging: false })
  onDragLeave = () => this.setState({ dragging: false })


  render() {
    return (
      <FileUpload
        HtmlFor="upld_tax_payment"
        FileError={this.state.fileConvertError}
        CAPTION="TAX PAYMENT"
        OnSelectFile={this.onSelectFileTaxPayment}
        UploadFile={this.uploadFile}
        Color="#F6C343"
        Accept=".csv,.txt"
      />
    );
  }
}
const mapStateToProps = ({ UserReducer, TaxPaymentReducer }) => ({ UserReducer, TaxPaymentReducer });

export default connect(mapStateToProps, { taxPaymentAction })(TaxPaymentsView);
